export const getTQHostUrl = (): string => {
  if (process.env.TQ_HOST_URL) {
    return process.env.TQ_HOST_URL;
  }
  if (
    process.env.NODE_ENV === 'production' &&
    !process.env.REACT_APP_CYPRESS_BASE_URL &&
    !process.env.REACT_APP_IS_CYPRESS_TEST
  ) {
    return `https://%TQ_HOST_URL%`;
  }

  if (process.env.REACT_APP_CYPRESS_BASE_URL) {
    return process.env.REACT_APP_CYPRESS_BASE_URL;
  }

  // localhost or process.env.REACT_APP_IS_CYPRESS_TEST is set
  return `http://localhost:${process.env.TQ_PORT || `3003`}`;
};

export const getSPMGeoCarveCdnUrl = () => {
  if (process.env.SPM_GEOCARVING_TILE_BASE_URL) {
    return process.env.SPM_GEOCARVING_TILE_BASE_URL;
  }
  const tqHostUrl = getTQHostUrl();

  // for localhost just return localhost url
  if (tqHostUrl.indexOf('localhost') > -1) {
    return tqHostUrl;
  }

  // for non-localhost return getTQHostUrl with tq. replaced with sp-geo.
  // i.e. https://tq.app-dog-usw2-cdn.captivateiq.com ->  https://sp-geo.app-dog-usw2-cdn.captivateiq.com
  // keep aligned with https://github.com/captivateiq/devops/blob/6938f6970e474b53618fe7e670a6c14e7c66e664/terraform/modules/compute/tq/spm_geocarving.tm.hcl#L93
  return tqHostUrl.replace('tq', 'sp-geo');
};
